import React from 'react';
import { Snackbar } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actionsSnackMensaje from '../../../actions/snackMensaje';

const SnackBarMensaje = (props) => {
    const vertical = 'bottom';
    const horizontal = 'left';

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        props.actualizarAtriutoSnackMensaje({
            mostrarSnack: false,
        });
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={props.mostrar}
            onClose={handleClose}
            message={props.mensaje}
            key={vertical + horizontal}
            autoHideDuration={3000}
        />
    );
};

const mapStateToProps = (state) => ({});

const actionCreators = {
    actualizarAtriutoSnackMensaje:
        actionsSnackMensaje.actualizarAtriutoSnackMensaje,
};

export default connect(mapStateToProps, actionCreators)(SnackBarMensaje);
